import { IsNotEmpty } from 'class-validator';
import { Mapper } from '../../../common/ddd/mapper.base';
import { IWorkingSessionsAnalyticsActivityEnum } from '../../../common/enum/working-sessions/working-sessions-analytics-activity.enum';
import { SelfFocusScoreAveragesSummaryEntity } from '../../../core/domain/entities/scores/self-focus-score-averages-summary.entity';
import { GetSelfScoreAveragesSummaryResponseDto } from '../../../interface/dtos/scores/self-get-score-averages-summary.response.dto';

export class SelfFocusScoreAveragesSummaryPersistenceDto {
  @IsNotEmpty()
  [IWorkingSessionsAnalyticsActivityEnum.TotalDuration]: number;

  @IsNotEmpty()
  [IWorkingSessionsAnalyticsActivityEnum.TotalFocusDuration]: number;

  @IsNotEmpty()
  [IWorkingSessionsAnalyticsActivityEnum.DayCount]: string;

  @IsNotEmpty()
  [IWorkingSessionsAnalyticsActivityEnum.WeekCount]: string;
}

export class SelfFocusScoreAveragesSummaryMapper
  implements
    Mapper<
      SelfFocusScoreAveragesSummaryEntity,
      GetSelfScoreAveragesSummaryResponseDto
    >
{
  toResponse(
    entity: SelfFocusScoreAveragesSummaryEntity
  ): GetSelfScoreAveragesSummaryResponseDto {
    return SelfFocusScoreAveragesSummaryMapper.toResponse(entity);
  }

  static toResponse(
    entity: SelfFocusScoreAveragesSummaryEntity
  ): GetSelfScoreAveragesSummaryResponseDto {
    return {
      dailyAverage: entity.averageDailyPercentage,
      weeklyAverage: entity.averageWeeklyPercentage,
      formattedDailyAverage: String(entity.averageDailyPercentage),
      formattedWeeklyAverage: String(entity.averageWeeklyPercentage),
    };
  }

  toDomain(
    record: SelfFocusScoreAveragesSummaryPersistenceDto
  ): SelfFocusScoreAveragesSummaryEntity {
    return SelfFocusScoreAveragesSummaryMapper.toDomain(record);
  }

  static toDomain(
    record: SelfFocusScoreAveragesSummaryPersistenceDto
  ): SelfFocusScoreAveragesSummaryEntity {
    const entity = SelfFocusScoreAveragesSummaryEntity.create({
      targetDuration: Number(
        record[IWorkingSessionsAnalyticsActivityEnum.TotalFocusDuration]
      ),
      totalDuration: Number(
        record[IWorkingSessionsAnalyticsActivityEnum.TotalDuration]
      ),
      dayCount: Number(record[IWorkingSessionsAnalyticsActivityEnum.DayCount]),
      weekCount: Number(
        record[IWorkingSessionsAnalyticsActivityEnum.WeekCount]
      ),
    });
    return entity;
  }
}
